import React, { Component } from 'react'
import './header.scss'
import {  withRouter } from 'react-router-dom'
import { getApiRegister , getApiLogin , getApiMobileLogin , getApiResetpwd , getApiSend } from "../../axios/api"
import { get, remove, set } from '../../axios/localstorage'
import { message , Cascader } from 'antd'

 class header extends Component {

  state = {
    key:"",
    data:{},
    account:"",
    company:"",
    password:"",
    msg:"",
    info:{},

    atype:0,

    mobile:"",
    newpsw:"",
    confirmpsw:"",
    code:"",

    countDownNum:60,  
    
    isSend: false,


    showInfo:false,
    showLogin:false,
    showRegister:false,
    showChange:false,
    showAuto:true,

    arr:[
      {label:"活动",value:0},
      {label:"专家",value:1},
      {label:"技术成果",value:2}
    ],
    arrType:0,
    arrName:"活动"
  }

  componentDidMount(){

    
    let nameData = get('name');
    if(nameData){
      this.setState({
          key:nameData.name,
          arrType:nameData.nameType
      })

      // remove('name')
  }
  let info = get('info');
    if(info){
      this.setState({
        info,
        showInfo:true
      })
    }else{
      this.setState({
        showInfo:false
      })
    }  
  }

  componentWillReceiveProps(){
    console.log(this.props);

    // if(this.props.name){
    //   this.setState({
    //     arrType:parseInt(this.props.nameType),
    //     // key:this.props.name
    //   })
    // }
  }

gotoOut=()=>{
  remove('info');
  remove('token');
  this.setState({
    showInfo:false
  })
}

gotoLogin=()=>{

  if(this.state.atype === 0){

    if(!this.state.account){
      this.setState({
        showMsg:true,
        msg:"请先输入账号！"
      })

      return false;
    }

    if(!this.state.password){
      this.setState({
        showMsg:true,
        msg:"请先输入密码！"
      })

      return false;
    }

    let param = {
      account:this.state.account,
      password:this.state.password
    }

    getApiLogin(param)
    .then( req =>{
      if(req.data.code === 1){

        let data = req.data.data;
        let info = data.userinfo;

        set("info",info);
        set("token",info.token);

        this.setState({
          info,
          showInfo:true,
          showLogin:false
        })

        message.success("登录成功");
        window.location.reload();

        this.clearInput();

      }else{
        this.setState({
          showMsg:true,
          msg:req.data.msg
        })
      }
    }).catch( err =>{
      console.error(err);
    })

  }else{

    if(!this.state.mobile){
      this.setState({
        showMsg:true,
        msg:"请先输入手机号！"
      })

      return false;
    }

    var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

    if (!myreg.test(this.state.mobile)) {

        this.setState({
          showMsg:true,
          msg:'手机号码格式不正确'
        })
        return false;
    }

    if(!this.state.code){
      this.setState({
        showMsg:true,
        msg:"请先输入验证码！"
      })

      return false;
    }


    let param = {
      mobile:this.state.mobile,
      captcha:this.state.code
    }

    getApiMobileLogin(param)
    .then( req =>{
      if(req.data.code === 1){

        let data = req.data.data;
        let info = data.userinfo;

        set("info",info);
        set("token",info.token);

        this.setState({
          info,
          showInfo:true,
          showLogin:false
        })

        message.success("登录成功");
        window.location.reload();
        this.clearInput();

      }else{
        this.setState({
          showMsg:true,
          msg:req.data.msg
        })
      }
    }).catch( err =>{
      console.error(err);
    })

  }

}



  gotoChange=()=>{

    if(!this.state.mobile){
      this.setState({
        showMsg:true,
        msg:"请先输入手机号！"
      })

      return false;
    }

    var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

    if (!myreg.test(this.state.mobile)) {

        this.setState({
          showMsg:true,
          msg:'手机号码格式不正确'
        })
        return false;
    }

    if(!this.state.code){
      this.setState({
        showMsg:true,
        msg:"请先输入验证码！"
      })

      return false;
    }
    if(!this.state.newpsw){
      this.setState({
        showMsg:true,
        msg:"请先输入密码！"
      })

      return false;
    }
    if(!this.state.confirmpsw){
      this.setState({
        showMsg:true,
        msg:"请再次确认密码！"
      })

      return false;
    }


    if(this.state.newpsw !== this.state.confirmpsw){
      this.setState({
        showMsg:true,
        msg:"两次密码输入不一致！"
      })

      return false;
    }

    let param = {
      mobile:this.state.mobile,
      newpassword:this.state.newpsw,
      captcha:this.state.code,
    }

    getApiResetpwd(param)
    .then( req =>{
      if(req.data.code === 1){
        message.success("修改成功,请去登录");
        this.setState({
          showLogin:true,
          showChange:false
        })
        this.clearInput();
      }else{
        this.setState({
          showMsg:true,
          msg:req.data.msg
        })
      }
    }).catch( err =>{
      console.error(err);
    })
  }


  gotoRegister=()=>{

    
    if(!this.state.mobile){
      this.setState({
        showMsg:true,
        msg:"请先输入手机号！"
      })

      return false;
    }

    var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

    if (!myreg.test(this.state.mobile)) {

        this.setState({
          showMsg:true,
          msg:'手机号码格式不正确'
        })
        return false;
    }

    if(!this.state.code){
      this.setState({
        showMsg:true,
        msg:"请先输入验证码！"
      })

      return false;
    }
    if(!this.state.newpsw){
      this.setState({
        showMsg:true,
        msg:"请先输入密码！"
      })

      return false;
    }
    if(!this.state.confirmpsw){
      this.setState({
        showMsg:true,
        msg:"请再次确认密码！"
      })

      return false;
    }


    if(this.state.newpsw !== this.state.confirmpsw){
      this.setState({
        showMsg:true,
        msg:"两次密码输入不一致！"
      })

      return false;
    }

    let param = {
      company:this.state.company,
      mobile:this.state.mobile,
      password:this.state.newpsw,
      code:this.state.code,
    }

    getApiRegister(param)
    .then( req =>{
      if(req.data.code === 1){
        message.success("注册成功,请去登录");
        this.setState({
          showLogin:true,
          showRegister:false
        })
        this.clearInput();
      }else{
        this.setState({
          showMsg:true,
          msg:req.data.msg
        })
      }
    }).catch( err =>{
      console.error(err);
    })
  }

  gotoPage=(page)=>{
      this.props.history.push(page);
  }

  gotoSend=()=>{

    if(!this.state.mobile){
        this.setState({
            msg:'请先输入手机号码！',
            showMsg:true
        })
        return false;
    }


    var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

    if (!myreg.test(this.state.mobile)){

        this.setState({
            msg:'手机号码格式不正确',
            showMsg:true
        })
        return false;
    }

    let event = "mobilelogin";

    if(this.state.showLogin){
      event = "mobilelogin"
    }

    if(this.state.showRegister){
      event = "register"
    }

    if(this.state.showChange){
      event = "resetpwd"
    }


    let param = {
        event:event,
        mobile:this.state.mobile
    }


    getApiSend(param)
    .then( req =>{
        if(req.data.code === 1){
            this.setState({
                isSend:true
            })
    
            this.countDown();
        }else{
            this.setState({
                msg:req.data.msg,
                showMsg:true
            })
        }
    }).catch( err =>{
        console.error(err);
    })

    
}

clearInput=()=>{
  this.setState({
    account:"",
    mobile:"",
    code:"",
    newpsw:"",
    password:"",
    confirmpsw:"",
    countDownNum:60,
    isSend:false,
    showMsg:false
  })

  if(this.props.loginType){
    this.props.hideLoginType()
  }
}

countDown=() =>{ 
    let countDownNum = this.state.countDownNum-1;//获取倒计时初始值
    //如果将定时器设置在外面，那么用户就看不到countDownNum的数值动态变化，所以要把定时器存进data里面
    this.timer = setInterval(() => {

        if(countDownNum<=0){
            clearInterval(this.timer);
            this.setState({ countDownNum:60,  isSend: false })
        }else{
            this.setState({
                countDownNum:(countDownNum--)
            })
        }
    }, 1000);
}






  render() {
    return (
      <div className="header">
        <div className='cen'>
          <div className='hmain'>
            <div className='hsbox'>
              <div className='hs_logo' onClick={()=>{this.gotoPage('/')}}>
                <img alt="" className="hs_img1" src="/www/assets/imgs/logo.png" />
                <img alt="" className="hs_img2" src="/www/assets/imgs/xuanwukeji.png" />
              </div>
              <div className='hsearch'>
                <div className='hst'>
                  <h2>{this.state.arrType?this.state.arr[this.state.arrType].label:this.state.arrName}</h2>
                  <img alt="" src="/www/assets/imgs/xiala.png" />
                  <div className='hss'></div>

                  <div className="casDiv">
                      <div className='cas'>
                      <Cascader
                      style={{borderColor:'#fff',flex:'1',opacity:0,width:"100%"}} popupClassName="Cascaderbox"
                      placeholder=' ' size="small" options={this.state.arr} 
                      onChange={(value,selectedOptions)=>{
                          console.log(value);
                          console.log(selectedOptions)
                          let data = selectedOptions[0];
                          if(data){
                              this.setState({
                                  arrType:data.value,
                                  arrName:data.label
                              })
                          }
                      }} />
                      </div>
                  </div>
                </div>
                
                <input type="text" placeholder='输入搜索内容' value={this.state.key} onChange={(ev)=>{

                  if(ev.target.value === ""){
                    remove('name');
                  }

                  this.setState({key:ev.target.value})
                  }} />
              </div>
              <div className='hicon' onClick={()=>{
                set('name',{name:this.state.key,nameType:this.state.arrType});

                if(this.state.arrType === 0){
                  if(this.props.location.pathname === '/activity'){
                    this.props.changeName(this.state.key);
                  }else{
                    this.gotoPage('/activity')
                  }
                  
                }else if(this.state.arrType === 1){
                  if(this.props.location.pathname === '/talents'){
                    this.props.changeName(this.state.key);
                  }else{
                    this.gotoPage('/talents')
                  }
                }else if(this.state.arrType === 2){
                  if(this.props.location.pathname === '/skill'){
                    this.props.changeName(this.state.key);
                  }else{
                    this.gotoPage('/skill')
                  }
                }
                
              }}>
                <img alt='' src="/www/assets/imgs/sousuo.png" />
              </div>
              <div className='hs_div' hidden={this.state.showInfo}>
                <button className='hs_btn1' onClick={()=>{this.setState({showLogin:true})}}>登录</button>
                <button className='hs_btn2' onClick={()=>{this.setState({showRegister:true})}}>注册</button>
              </div>
              <div className='hs_div' hidden={!this.state.showInfo}>
                  <div className='hs_avatar' style={{backgroundImage:"url('"+this.state.info.avatar+"')"}}></div>
                  <p>{this.state.info.nickname}</p>
                  <div className='hs_out' onClick={()=>{this.gotoOut()}}>
                    退出登录
                  </div>
              </div>
              
            </div>
          </div>
        </div>
        <div className='cen blue_bg'>
          <div className='hmain'>
            <div className='htop'>
              <div className='htbox'>
                  <div onClick={()=>{this.gotoPage('/')}} className={this.props.type === 1?'hti active':'hti'}>首页<div className='hcen'><img alt="" src="/www/assets/imgs/xiasanjiao.png"  /></div><div className='hspan'></div></div>
                  
                  <div onClick={()=>{this.gotoPage('/industrialMap')}} className={this.props.type === 3?'hti active':'hti'}>产业图谱<div className='hcen'><img alt="" src="/www/assets/imgs/xiasanjiao.png"  /></div><div className='hspan'></div></div>
                  <div onClick={()=>{this.gotoPage('/service')}} className={this.props.type === 4?'hti active':'hti'}>服务大厅<div className='hcen'><img alt="" src="/www/assets/imgs/xiasanjiao.png"  /></div><div className='hspan'></div></div>
                  <div onClick={()=>{this.gotoPage('/talents')}} className={this.props.type === 5?'hti active':'hti'}>专家人才<div className='hcen'><img alt="" src="/www/assets/imgs/xiasanjiao.png"  /></div><div className='hspan'></div></div>
                  <div onClick={()=>{this.gotoPage('/skill')}} className={this.props.type === 6?'hti active':'hti'}>科技成果<div className='hcen'><img alt="" src="/www/assets/imgs/xiasanjiao.png"  /></div><div className='hspan'></div></div>
                  
                  <div onClick={()=>{

                  if(!get('token')){
                    // message.info("请先登录")
                    this.setState({
                      showLogin:true
                    })
                    return false;
                  }

                  this.gotoPage('/policy')
                  }} className={this.props.type === 2?'hti active':'hti'}>科创政策<div className='hcen'><img alt="" src="/www/assets/imgs/xiasanjiao.png"  /></div><div className='hspan'></div></div>
                  <div onClick={()=>{this.gotoPage('/project')}} className={this.props.type === 10?'hti active':'hti'}>项目选址<div className='hcen'><img alt="" src="/www/assets/imgs/xiasanjiao.png"  /></div><div className='hspan'></div></div>
                  <div onClick={()=>{window.open('https://course.pkusp.com/')}} className={this.props.type === 7?'hti active':'hti'}>培训课程<div className='hcen'><img alt="" src="/www/assets/imgs/xiasanjiao.png"  /></div><div className='hspan'></div></div>
                  <div onClick={()=>{this.gotoPage('/activity')}} className={this.props.type === 8?'hti active':'hti'}>科创活动<div className='hcen'><img alt="" src="/www/assets/imgs/xiasanjiao.png"  /></div><div className='hspan'></div></div>
                  <div onClick={()=>{

                    if(this.props.type === 1){
                      window.scroll(0, 5000);
                    }else{
                      this.gotoPage('/home?end=1')
                    }
                    
                    }} className={this.props.type === 9?'hti active':'hti'}>硅巷载体<div className='hcen'><img alt="" src="/www/assets/imgs/xiasanjiao.png"  /></div><div className='hspan'></div>
                  </div>
              </div>
            </div>
          </div>
        </div>

        <div className='alert' hidden={!this.state.showLogin && !this.props.loginType}>
          <div className='a_login'>
            <img className='aclose' onClick={()=>{
              this.setState({showLogin:false,showMsg:false});
              this.clearInput();
              if(this.props.loginType){
                this.props.hideLoginType()
              }
              }} alt="" src="/www/assets/imgs/chacha.png" />
            <div className='atype'>
              <div className={this.state.atype === 0 ?'ati':'ati anone'} onClick={()=>{this.setState({atype:0})}}>
                <h1>密码登录</h1>
                <div className='cen'>
                  <div className='aspan'></div>
                </div>
              </div>
              <div className='asp'></div>
              <div className={this.state.atype === 1 ?'ati':'ati anone'} onClick={()=>{this.setState({atype:1})}}>
                <h1>动态登录</h1>
                <div className='cen'>
                  <div className='aspan'></div>
                </div>
              </div>
            </div>
            
            <div hidden={this.state.atype === 1}>
              <div className='aipt'>
                <img alt="" src="/www/assets/imgs/zhanghu.png" />
                <input type="text" placeholder='账户' value={this.state.account} onChange={(ev)=>{this.setState({account:ev.target.value})}} />
              </div>
              <div className='aipt'>
                <img alt="" src="/www/assets/imgs/mima.png" />
                <input type="password" placeholder='密码' value={this.state.password} onChange={(ev)=>{this.setState({password:ev.target.value})}} />
              </div>
            </div>
            <div hidden={this.state.atype === 0}>
              <div className='aipt'>
                <img alt="" src="/www/assets/imgs/shoujihao.png" />
                <input type="text" placeholder='手机号' value={this.state.mobile} onChange={(ev)=>{this.setState({mobile:ev.target.value})}} />
              </div>
              <div className='aipt2'>
                  <div>
                      <input type="text" placeholder='请输入验证码' value={this.state.code} onChange={(ev)=>{this.setState({code:ev.target.value})}} />
                  </div>
                  <button onClick={()=>{this.gotoSend()}} className={this.state.isSend?'send':''}>{this.state.isSend?this.state.countDownNum + "s 后重发":"发送验证码"}</button>
              </div>
            </div>
            <div className='a_other'>
              <div className='adiv' onClick={()=>{this.setState({showAuto:!this.state.showAuto})}}>
                <div>
                  <img hidden={!this.state.showAuto} alt='' src="/www/assets/imgs/xuanzhong.png" />
                </div>
                <p>自动登录</p>
              </div>
              <h4 onClick={()=>{this.setState({showChange:true,showLogin:false,showMsg:false});this.clearInput()}}>忘记密码？</h4>
            </div>
            <div className='amsg'>
                <p hidden={!this.state.showMsg}>{this.state.msg}</p>
            </div>
            <button className='abtn' onClick={()=>{this.gotoLogin()}}>登 录</button>
            <h2 className='ah2' onClick={()=>{this.setState({showRegister:true,showLogin:false,showMsg:false,});this.clearInput()}}>还没有账号？立即注册账号</h2>
          </div>
        </div>

        <div className='alert' hidden={!this.state.showRegister}>
            <div className='ares'>
              <h1>注册账号</h1>
              <img className='aclose' onClick={()=>{this.setState({showRegister:false,showMsg:false});this.clearInput()}} alt="" src="/www/assets/imgs/chacha.png" />
              {/* <h2>企业名称</h2>
              <input type="text" placeholder='请输入企业名称' value={this.state.company} onChange={(ev)=>{this.setState({company:ev.target.value})}} /> */}
              <h2>手机号</h2>
              <input type="text" placeholder='请输入手机号' value={this.state.mobile} onChange={(ev)=>{this.setState({mobile:ev.target.value})}} />
              <h2>验证码</h2>
              <div className='aipt'>
                  <div>
                      <input type="text" placeholder='请输入验证码' value={this.state.code} onChange={(ev)=>{this.setState({code:ev.target.value})}} />
                  </div>
                  <button onClick={()=>{this.gotoSend()}} className={this.state.isSend?'send':''}>{this.state.isSend?this.state.countDownNum + "s 后重发":"发送验证码"}</button>
              </div>
              <h2>密码</h2>
              <input type="password" placeholder='请输入密码' value={this.state.newpsw} onChange={(ev)=>{this.setState({newpsw:ev.target.value})}} />
              <h2>确认密码</h2>
              <input type="password" placeholder='请确认新密码' value={this.state.confirmpsw} onChange={(ev)=>{this.setState({confirmpsw:ev.target.value})}} />
              
              <div className='amsg'>
                  <p hidden={!this.state.showMsg}>{this.state.msg}</p>
              </div>
              <button className='abtn' onClick={()=>{this.gotoRegister()}}>注册</button>
              <h4 className='ah2' onClick={()=>{this.setState({showRegister:false,showLogin:true,showMsg:false});this.clearInput()}}>已有账号？立即登录</h4>
            </div>
        </div>

        <div className='alert' hidden={!this.state.showChange}>
          <div className='a_change'>
              <h1>修改密码</h1>
              <img className='aclose' onClick={()=>{this.setState({showChange:false});this.clearInput()}} alt="" src="/www/assets/imgs/chacha.png" />
              <h2>手机号</h2>
              <input type="text" placeholder='请输入手机号' value={this.state.mobile} onChange={(ev)=>{this.setState({mobile:ev.target.value})}} />
              <h2>验证码</h2>
              <div className='aipt'>
                  <div>
                      <input type="text" placeholder='请输入验证码' value={this.state.code} onChange={(ev)=>{this.setState({code:ev.target.value})}} />
                  </div>
                  <button onClick={()=>{this.gotoSend()}} className={this.state.isSend?'send':''}>{this.state.isSend?this.state.countDownNum + "s 后重发":"发送验证码"}</button>
              </div>
              <h2>新密码</h2>
              <input type="password" placeholder='请输入新密码' value={this.state.newpsw} onChange={(ev)=>{this.setState({newpsw:ev.target.value})}} />
              <h2>确认密码</h2>
              <input type="password" placeholder='请确认新密码' value={this.state.confirmpsw} onChange={(ev)=>{this.setState({confirmpsw:ev.target.value})}} />
              <div className='amsg'>
                  <p hidden={!this.state.showMsg}>{this.state.msg}</p>
              </div>
              <button className='abtn' onClick={()=>{this.gotoChange()}}>更新密码</button>
              <h4 className='ah2' onClick={()=>{this.setState({showChange:false,showLogin:true});this.clearInput()}}>想起密码了？立即登录</h4>
          </div>
        </div>

      </div>
    )
  }
}
export default withRouter(header);